import { createSelector } from 'reselect';

import { selectAddToCartState } from './selectAddToCartState';

export const selectModalVisible = createSelector(
  selectAddToCartState,
  (addToCartModalState) => addToCartModalState?.savedProductIds ?? [],
);
